<div class="w-full">
  <div *ngIf="modo==='normal'">
    <section class="flex flex-col sm:flex-row sm:flex-wrap sm:justify-center md:justify-between gap-6 md:gap-10 px-6 sm:px-8 md:px-16 py-6 md:py-8 bg-[var(--pieColor,var(--foo-ecommerce-color))]">
      <!-- Columna 1: Institucional -->
      <div class="flex-1 min-w-[220px] flex flex-col items-center md:items-start text-center md:text-left">
        <div class="mb-2.5 font-bold text-sm uppercase tracking-wide capitalize text-[var(--foo-text-ecommerce-color)]">Institucional</div>
        <div class="flex flex-col gap-1.5 w-full">
          <div *ngIf="data_Empresa" class="cursor-pointer text-sm capitalize text-[var(--pieColorTexto,var(--foo-text-ecommerce-color))]" (click)="goToInfo('modal-data-empresa')">
            Nuestra Empresa
          </div>
          <div *ngIf="work_With_As" class="cursor-pointer text-sm capitalize text-[var(--pieColorTexto,var(--foo-text-ecommerce-color))]" (click)="goToInfo('modal-work-withAs')">
            Trabajá con nosotros
          </div>
          <div *ngIf="info_Prov" class="cursor-pointer text-sm capitalize text-[var(--pieColorTexto,var(--foo-text-ecommerce-color))]" (click)="goToInfo('modal-info-prov')">
            Proveedores
          </div>
          <div *ngIf="terminos_condiciones" class="cursor-pointer text-sm capitalize text-[var(--pieColorTexto,var(--foo-text-ecommerce-color))]" (click)="goToInfo('modal-terminos-condiciones')">
            Términos y Condiciones
          </div>
          <div *ngIf="informacion_envio" class="text-sm capitalize">
            <a [href]="informacion_envio" class="text-[var(--pieColorTexto,var(--foo-text-ecommerce-color))] no-underline" target="_blank">Información de Envíos</a>
          </div>
          <div *ngIf="politica_devoluciones" class="text-sm capitalize">
            <a [href]="politica_devoluciones" class="text-[var(--pieColorTexto,var(--foo-text-ecommerce-color))] no-underline" target="_blank">Políticas de devoluciones</a>
          </div>
        </div>
      </div>

      <!-- Columna 2: Ayuda y Botones -->
      <div class="flex-1 min-w-[220px] flex flex-col items-center md:items-start text-center md:text-left">
        <div class="mb-2.5 font-bold text-sm uppercase tracking-wide capitalize text-[var(--foo-text-ecommerce-color)]">Servicio al Cliente</div>
        <div class="mb-3 text-[var(--foo-text-ecommerce-color)]">
          <div class="text-xs opacity-80 mb-0.5">¿Necesitás Ayuda?</div>
          <div class="text-lg font-extrabold tracking-wide">{{telefonoAtencionAlCliente}}</div>
        </div>
        <div class="flex flex-col gap-2 items-center md:items-start w-full">
          <div *ngIf="botonNovedades" class="w-full flex justify-center md:justify-start">
            <a [href]="botonNovedades" target="_blank">
              <button class="bg-white text-primary border border-white rounded-md px-3 py-1.5 text-xs font-bold uppercase tracking-wide transition-base duration-base hover:bg-transparent hover:text-white hover:border-white">
                Novedades
              </button>
            </a>
          </div>
          <div class="w-full flex justify-center md:justify-start" (click)="arrepentimiento()">
            <button class="bg-transparent text-[var(--pieColorTexto,white)] border border-[var(--pieColorTexto,white)] rounded-md px-3 py-1.5 text-xs font-bold uppercase tracking-wide transition-base duration-base hover:bg-white hover:text-primary hover:border-white hover:shadow-sm">
              Botón de Arrepentimiento
            </button>
          </div>
        </div>
      </div>

      <!-- Columna 3: Redes Sociales -->
      <div class="flex-1 min-w-[220px] flex flex-col items-center md:items-start text-center md:text-left">
        <div class="mb-2.5 font-bold text-sm uppercase tracking-wide capitalize text-[var(--foo-text-ecommerce-color)]">Seguinos</div>
        <div class="flex flex-row flex-wrap gap-2 justify-center md:justify-start">
          <div class="w-9 h-9 flex justify-center items-center" *ngFor="let red of redes">
            <a [href]="red.link" target="_blank">
              <img class="object-contain" [width]="22" [height]="22" [src]="red.urlIcono" [alt]="red.nombre">
            </a>
          </div>
        </div>
      </div>
    </section>
    <div class="flex flex-col sm:flex-row justify-center items-center gap-1 sm:gap-2 px-6 sm:px-11 md:px-12 py-2 text-xs font-semibold text-[#dbdbdb] w-full box-border bg-[var(--pieColor,var(--accent-color))] text-center">
      <a href="https://www.dlr.com.ar" target="_blank" rel="noopener noreferrer" class="hover:underline">DLR Software {{year}}</a>
      <span>{{menuWatermarkMensaje}}</span>
    </div>
  </div>

  <modal-open-point id="modal-arrepentimiento">
    <div normal class="bubletext">
      <modal-arrepentimiento></modal-arrepentimiento>
    </div>
  </modal-open-point>

</div>
